<template>
    <div>
        <MobileTitleWithBack v-if="$vuetify.breakpoint.xsOnly">
            Email
        </MobileTitleWithBack>
        <v-row
            :class="$vuetify.breakpoint.smAndUp ? 'pl-8' : ''"
        >
            <v-col
                v-if="$vuetify.breakpoint.smAndUp"
                cols="4"
            >
                <ProfileNavigation />
            </v-col>
            <v-col>
                <Email />
            </v-col>
        </v-row>
    </div>
</template>
<script>
import MobileTitleWithBack from '@/components/MobileTitleWithBack';
import ProfileNavigation from '@/components/ProfileSettings/ProfileNavigation';
import Email from '@/components/ProfileSettings/Email';

export default {
    components: {
        MobileTitleWithBack,
        ProfileNavigation,
        Email,
    },
};
</script>
